import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
// import Product from './views/Product.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/naturalDetail',
      name: 'naturalDetail',
      component: () => import('./views/NaturalDetail.vue')
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue')
    },
    {
      path: '/productDetail',
      name: 'productDetail',
      component: () => import('./views/ProductDetail.vue')
    },
    {
      path: '/business',
      name: 'business',
      component: () => import('./views/Business.vue')
    },
    {
      path: '/businessDetail',
      name: 'businessDetail',
      component: () => import('./views/BusinessDetail.vue')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('./views/Download.vue')
    },
    {
      path: '/mirror/*',
      name: 'mirror',
      component: () => import('@/views/down.vue')
    },
    {
      path: '/course',
      name: 'course',
      component: () => import('./views/Course.vue')
    },
    {
      path: '/courseDetail',
      name: 'courseDetail',
      component: () => import('./views/CourseDetail.vue')
    },
    {
      path: '/courseDetail2',
      name: 'courseDetail2',
      component: () => import('./views/CourseDetail2.vue')
    },
    {
      path: '/brand',
      name: 'brand',
      component: () => import('./views/Brand.vue')
    },
    {
      path: '/brandDetail',
      name: 'brandDetail',
      component: () => import('./views/BrandDetail.vue')
    },
    {
      path: '/connection',
      name: 'connection',
      component: () => import('./views/Connection.vue')
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  },
})
